import request from '@/utils/request'

// 公司启用/禁用状态更新接口
export function companyUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/updateState',
    method: 'POST',
    data,
  })
}
// 新建公司接口
export function companyAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/add',
    method: 'POST',
    data,
  })
}
// 公司详情页查询接口
export function companyDetail(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/detail',
    method: 'POST',
    data,
  })
}
// 公司详情页编辑接口
export function companyEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/edit',
    method: 'POST',
    data,
  })
}

// 客户列表导出接口
export function customerExport(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/export',
    method: 'POST',
    data,
  })
}
// 客户管理新增接口
export function customerAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/add',
    method: 'POST',
    data,
  })
}

// 客户管理编辑接口
export function customerEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/edit',
    method: 'POST',
    data,
  })
}
// 启用禁用状态更新接口
export function customerUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/updateState',
    method: 'POST',
    data,
  })
}
// 服务商列表查询接口
export function providerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}
// 服务商新增接口
export function providerAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/add',
    method: 'POST',
    data,
  })
}
// 服务商编辑接口
export function providerEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/edit',
    method: 'POST',
    data,
  })
}
// 启用禁用状态更新接口
export function providerUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/updateState',
    method: 'POST',
    data,
  })
}
// 车型列表查询接口
export function carModelList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/list',
    method: 'POST',
    data,
  })
}
// 品牌查询接口
export function carBrandList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/model/brandList',
    method: 'POST',
    data,
  })
}
// 车型列表查询接口
export function carSeriesList(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/seriesList',
    method: 'POST',
    data,
  })
}
// 新增车型
export function carModelAdd(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/add',
    method: 'POST',
    data,
  })
}

// 编辑车型
export function carModelEdit(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/edit',
    method: 'POST',
    data,
  })
}

// 启用禁用状态更新接口
export function carModelUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/car/model/updateState',
    method: 'POST',
    data,
  })
}
// 合同模板列表查询接口
export function contractTmpList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/list',
    method: 'POST',
    data,
  })
}

// 根据企业名称获取SP列表
export function getSpNameList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/merchant/getSpName',
    method: 'POST',
    data,
  })
}


// 合同模板列表新增接口
export function contractTmpAdd(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/add',
    method: 'POST',
    data,
  })
}
// 合同模板编辑接口
export function contractTmpEdit(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/edit',
    method: 'POST',
    data,
  })
}
// 启用禁用状态更新接口
export function contractTmpUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/updateState',
    method: 'POST',
    data,
  })
}
// 合同模板动态字段查询接口
export function contractTmpVariables(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/variables',
    method: 'POST',
    data,
  })
}
// 合同模板预览接口
export function contractTmpPreview(data) {
  return request({
    url: '/admin/v1/vehicle/contract/template/preview',
    method: 'POST',
    data,
  })
}
// 系统日志接口
export function operationLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operationLog/list',
    method: 'POST',
    data,
  })
}
// 系统日志接口
export function apiOperationLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operation/list',
    method: 'POST',
    data,
  })
}

// 支付日志
export function withholdExecLogList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/log/list',
    method: 'POST',
    data,
  })
}

// 业务操作日志 - 操作类型 操作内容
export function apiOperationType(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operation/operateMapping',
    method: 'POST',
    data,
  })
}
// 系统日志接口
export function operationLoginLogList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/system/operationLog/login/list',
    method: 'POST',
    data,
  })
}

// 系统员工账号管理所属角色
export function roleList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/list',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理新建员工
export function userAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/addUser',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理编辑员工
export function userEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/editUser',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理启用/禁用
export function userUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/updateState',
    method: 'POST',
    data,
  })
}
// 系统员工账号管理修改密码
export function resetPassword(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/resetPassword',
    method: 'POST',
    data,
  })
}
// 公告列表查询接口
export function noticeList(data) {
  return request({
    url: '/admin/v1/vehicle/notice/list',
    method: 'POST',
    data,
  })
}
// 公告详情接口
export function noticeDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/notice/detail',
    method: 'POST',
    data,
  })
}
// 公告新增接口
export function noticeAdd(data) {
  return request({
    url: '/admin/v1/vehicle/notice/add',
    method: 'POST',
    data,
  })
}
// 公告编辑接口
export function noticeEdit(data) {
  return request({
    url: '/admin/v1/vehicle/notice/edit',
    method: 'POST',
    data,
  })
}
// 公告启用/禁用状态接口
export function noticeUpdateState(data) {
  return request({
    url: '/admin/v1/vehicle/notice/updateState',
    method: 'POST',
    data,
  })
}

// 公司超管用户列表接口
export function superAdminList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/userList',
    method: 'POST',
    data,
  })
}
// 公司超管用户编辑接口
export function superAdminEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/editUser',
    method: 'POST',
    data,
  })
}
// 员工角色新增/编辑接口
export function roleAddEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/saveOrUpdate',
    method: 'POST',
    data,
  })
}
// 员工角色删除接口
export function roleDel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/delete',
    method: 'POST',
    data,
  })
}
// 公司信息营业执照OCR接口
export function ocrBizLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/bizLicense',
    method: 'POST',
    data,
  })
}
// new公司信息营业执照OCR接口
export function detailedBizLicense(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/detailedBizLicense',
    method: 'POST',
    data,
  })
}
// 身份证OCR接口
export function ocrIdcard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/ocr/idcard',
    method: 'POST',
    data,
  })
}

// 公司员工删除
export function userDelete(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/company/deleteStaff',
    method: 'POST',
    data,
  })
}

// 客户管理详情页查看接口
export function getCustomerDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/detail',
    method: 'POST',
    data,
  })
}

// 客户管理详情页查看接口
export function customerExcel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/importExcel',
    method: 'POST',
    data,
  })
}

// 服务商详情页接口
export function companyProviderDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/detail',
    method: 'POST',
    data,
  })
}

// 自定义标签查询
export function getTenantCustomTagList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/list',
    method: 'POST',
    data,
  })
}

// 不可租标签查询
export function getNonRentableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/non-rentable/list',
    method: 'POST',
    data,
  })
}

// 预览
export function effectPreview(params) {
  return request({
    url: '/admin/v1/vehicle/contract/template/effectPreview',
    method: 'get',
    params,
  })
}
// 检查租户是否开通服务
export function checkConfigState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/getState',
    method: 'POST',
    data,
  })
}


// 待办任务记录列表
export function affairsItems(data = {}) {
  return request({
    url: '/admin/v1/vehicle/affairs/items',
    method: 'POST',
    data,
  })
}

// 获取签约主体列表 https://mock-test.cheweijia.com/project/10282/interface/api/492667
export function orderMerchantList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/merchant/list',
    method: 'POST',
    data,
  })
}
